import PropTypes from "prop-types"
import Icon from "components/planning_center_icon"

const AttendeeAddons = ({ attendee }) => {
  return (
    <div
      className={`line p-2 registration-details ${!attendee.addonSelections.length > 0 &&
        "d-n@print"}`}
    >
      <div className="d-f ai-c jc-sb mb-2">
        <h4 className="mb-0 fw-600 d-f ai-c g-1">
          <span>Add-ons</span>
          {attendee.isMissingRequiredAddOns && (
            <Icon className="c-warning-icon font-size-4" symbol="general#exclamation-triangle" />
          )}
        </h4>
        <button className="btn-outline xs" data-modal-url={attendee.paths.editAttendeeAddOn}>
          Edit
        </button>
      </div>

      <ul className="unstyled mb-0">
        {attendee.addonSelections.map(aos => (
          <li key={aos.id} className="mb-1">
            {aos.addOnableName}

            <span className="caption-text ml-4p">
              {aos.quantity > 1 ? (
                <>
                  {`(${aos.quantity}`}
                  <span className="ml-2p mr-2p">&times;</span>
                  {`${aos.eachCost}${aos.isRequired ? ", required" : ""})`}
                </>
              ) : (
                `(${aos.totalCost}${aos.isRequired ? ", required" : ""})`
              )}
            </span>
          </li>
        ))}
        {!attendee.addonSelections.length > 0 && <li className="d-n@print">None</li>}
      </ul>
    </div>
  )
}

AttendeeAddons.propTypes = {
  attendee: PropTypes.shape({
    addonSelections: PropTypes.array,
    paths: PropTypes.shape({
      editAttendeeAddOn: PropTypes.string
    }),
    isMissingRequiredAddOns: PropTypes.bool
  })
}

export default AttendeeAddons
